"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var lodash_1 = require("lodash");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var currency_control_state_1 = require("../../../currency-control.state");
var utilities_1 = require("../../../utilities");
exports.FRACTION_DIGITS = 4;
var RateInputComponent = /** @class */ (function () {
    function RateInputComponent(formattingService, cd) {
        this.formattingService = formattingService;
        this.cd = cd;
        this.rateAsString = '';
        this.blur = new Subject_1.Subject();
        this.destroy = new Subject_1.Subject();
        this.logger = utilities_1.createLogger('rate-input');
    }
    RateInputComponent.prototype.handleKeyPress = function (event) {
        if (!/[0-9.,]/.test(event.key)) {
            event.preventDefault();
        }
    };
    RateInputComponent.prototype.onBlur = function () {
        this.blur.next();
    };
    RateInputComponent.prototype.reset = function () {
        this.accountingState.reset();
    };
    RateInputComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.accountingState
            .getAccounting()
            .pipe(operators_1.map(function (accounting) { return accounting.rateToDefault; }), operators_1.distinctUntilChanged(), operators_1.switchMap(function (rate) { return _this.formatRate(rate); }), operators_1.takeUntil(this.destroy))
            .subscribe(function (formattedRate) {
            _this.rateAsString = formattedRate;
            _this.cd.detectChanges();
        }, function (err) { return _this.logger.error('%O', err); });
        this.blur
            .pipe(operators_1.switchMap(function () {
            return _this.formattingService.parseNumber(_this.rateAsString);
        }), operators_1.map(function (rate) { return utilities_1.round(rate, exports.FRACTION_DIGITS); }), operators_1.tap(function (rate) { return _this.accountingState.updateRate(rate); }), operators_1.switchMap(function (rate) { return _this.formatRate(rate); }), operators_1.takeUntil(this.destroy))
            .subscribe(function (rateAsString) {
            _this.rateAsString = rateAsString;
            _this.cd.detectChanges();
        }, function (err) { return _this.logger.error('%O', err); });
        this.accountingState
            .getIsCustom()
            .pipe(operators_1.takeUntil(this.destroy))
            .subscribe(function (isCustom) {
            _this.isCustom = isCustom;
            _this.cd.detectChanges();
        }, function (err) { return _this.logger.error(err); });
    };
    RateInputComponent.prototype.ngOnDestroy = function () {
        this.destroy.next();
        this.destroy.complete();
    };
    RateInputComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Workaround
        // https://github.com/angular/components/issues/8988
        // https://github.com/angular/components/pull/10670
        this.matSuffix.changes.pipe(operators_1.takeUntil(this.destroy)).subscribe(function () { return _this.formField['_changeDetectorRef'].detectChanges(); }, function (err) { return _this.logger.error(err); });
    };
    RateInputComponent.prototype.formatRate = function (number) {
        if (lodash_1.isNil(number) || isNaN(number)) {
            return of_1.of('');
        }
        return this.formattingService.formatNumber(number, {
            fractionDigits: exports.FRACTION_DIGITS,
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RateInputComponent.prototype, "hint", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", currency_control_state_1.CurrencyControlState)
    ], RateInputComponent.prototype, "accountingState", void 0);
    __decorate([
        core_1.ViewChildren(material_1.MatSuffix),
        __metadata("design:type", core_1.QueryList)
    ], RateInputComponent.prototype, "matSuffix", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatFormField),
        __metadata("design:type", material_1.MatFormField)
    ], RateInputComponent.prototype, "formField", void 0);
    RateInputComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'rate-input',
            template: require('./rate-input.component.html'),
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }),
        __metadata("design:paramtypes", [idm_frontend_shared_1.FormattingService,
            core_1.ChangeDetectorRef])
    ], RateInputComponent);
    return RateInputComponent;
}());
exports.RateInputComponent = RateInputComponent;
//# sourceMappingURL=rate-input.component.js.map